<template>
  <div>
    <div class="horizontal-chapters px-3 px-sm-0 stretch pb-2" v-if="screenWidth < 720">
      <chapter v-for="c in chapters" :chapter="c" :key="c.id" :service="service" />
    </div>

    <div v-if="screenWidth >= 720" class="row mr-0">
      <div class="col-12 col-md-6 pr-3 pr-md-0 stretch" v-for="c in chapters">
        <chapter :chapter="c" :key="c.id" :service="service" />
      </div>
    </div>
  </div>
</template>

<script>
import Chapter from "../molecules/Chapter";

export default {
  components: { Chapter },
  props: {
    chapters: Array,
    service: String,
  },
  data() {
    return {
      screenWidth: 1200,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped lang="scss">
.competence-block {
  background-color: $color-dark-600;
  @include border-radius(0.25rem);
}

.horizontal-chapters {
  overflow-x: auto;
  white-space: pre-line;
}

.stretch {
  display: flex;
  align-items: stretch;
}

.horizontal-chapters div {
  margin-right: $spacer;
  min-width: 300px;
  max-width: 320px;
}

.horizontal-chapters:after {
  content: "-";
  color: transparent;
  max-width: 4px;
}
</style>
